import React from 'react';
import { Box, Stack, Skeleton, useTheme, useMediaQuery } from '@mui/material';

const BarChartSkeleton: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      {/* Stats Row Skeleton */}
      <Stack 
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        mb={4} 
        sx={{
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
          '& > *': {
            flex: { xs: '1 1 100%', sm: '1 1 0' },
            minWidth: 'auto'
          }
        }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              px: 2,
              py: 1.5,
              borderRadius: 1.5,
              border: '1px solid #E5E7EB',
              height: 80
            }}
          >
            <Skeleton 
              variant="rectangular" 
              width={40} 
              height={40} 
              sx={{ borderRadius: 1.5 }} 
            />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="40%" height={24} sx={{ mt: 0.5 }} />
            </Box>
          </Box>
        ))}
      </Stack>

      {/* Bar Chart Skeleton */}
      <Box sx={{ 
        width: '100%', 
        height: { 
          xs: 250, 
          sm: 275,
          md: 300 
        },
        mt: { xs: 2, sm: 3 },
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-around',
        px: 2,
        pb: 2
      }}>
        {/* Y-axis label area */}
        <Box sx={{ 
          position: 'absolute', 
          left: 10, 
          top: '50%', 
          transform: 'translateY(-50%) rotate(-90deg)',
          transformOrigin: 'center'
        }}>
          <Skeleton variant="text" width={100} height={16} />
        </Box>
        
        {/* Bars */}
        {Array.from({ length: isMobile ? 4 : 8 }).map((_, index) => (
          <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, maxWidth: 60 }}>
            <Skeleton 
              variant="rectangular" 
              width={isMobile ? 20 : 25}
              height={Math.random() * 150 + 50} // Random heights between 50-200px
              sx={{ 
                borderRadius: '4px 4px 0 0',
                mb: 1,
                bgcolor: '#E5E7EB'
              }} 
            />
            <Skeleton variant="text" width={40} height={16} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BarChartSkeleton;
